import { Box, Card, Typography } from "@mui/material";
import type { ReactNode } from "react";

import { HOME_CARD_SHADOW, HOME_COLORS } from "./homeTheme";

interface HomePanelProps {
  title: string;
  aside?: ReactNode;
  children: ReactNode;
  flex?: string;
}

export function HomePanel({ title, aside, children, flex }: HomePanelProps) {
  return (
    <Card
      component="section"
      aria-label={title}
      sx={{
        p: 2.5,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        boxShadow: HOME_CARD_SHADOW,
        minWidth: 0,
        flex,
      }}
    >
      <Box
        display="flex"
        alignItems="baseline"
        justifyContent="space-between"
        gap={2}
      >
        <Typography component="h2" sx={{ fontSize: 16, fontWeight: 500 }}>
          {title}
        </Typography>
        {aside && (
          <Typography sx={{ fontSize: 12, color: HOME_COLORS.muted }}>
            {aside}
          </Typography>
        )}
      </Box>
      {children}
    </Card>
  );
}
